import React from "react";

// --- contact images ---
import img03 from "../../images/contact/Logo.png";

// ---- contact items data ----
const contactData = [

  {
    location: "Monterrey, N.L. México",
    phone: (
    <>
      &#40;+52&#41; 81 1577 7026
      <br />
    </>
  ),
    email: "contacto@genusfilms.com",
    img: img03,
  },
];

const ContactInfoSection: React.FC = () => {
  return (
    <section className="contact pb-150">
      <div className="container">
        <div className="row mt-none-30 justify-content-center">

          {contactData.map((item, index) => (
<div className="col-lg-6 col-md-6 mt-30 d-flex justify-content-center" key={index}>
  <div className="xb-contact-items xb-border contact-card-custom">
    <div className="xb-item--inner d-flex align-items-center gap-4">

      <div className="contact-card-img">
        <img src={item.img} alt="location" />
      </div>

      <div className="xb-item--holder contact-card-info">
        <p className="xb-item--location mb-2">{item.location}</p>

        <span className="xb-item--contact_info d-block">{item.phone}</span>
        <span className="xb-item--contact_info d-block">{item.email}</span>
      </div>

    </div>
  </div>
</div>


          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
